angular
  .module('contabilidad.reportenominasmovimientos')
  .service('ContabilidadReportenominasmovimientosEmpresasClientes', ContabilidadReportenominasmovimientosEmpresasClientes)

ContabilidadReportenominasmovimientosEmpresasClientes.$inject = ['$http']

function ContabilidadReportenominasmovimientosEmpresasClientes ($http) {
  this.get = get

  function get (empresa_id) {
    return $http.get('/api/nominas/reportes/movimientos/empresas/clientes', {
      params: {
        empresa_id: empresa_id,
      },
    })
  }

}




// WEBPACK FOOTER //
// ./src/contabilidad/reportenominasmovimientos/services/ReportenominasmovimientosEmpresasClientes.js